import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, forkJoin, map, mergeMap, of } from 'rxjs';
import { RepoBusinessService } from '../../services/repo-business.service';
import * as repoBusinessActions from './repo-business.action';

@Injectable()
export class RepoBusinessEffects {
  constructor(
    private actions$: Actions,
    private repoBusinessService: RepoBusinessService
  ) { }


 

  loadRepoBusinesses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.loadRepoBusinesses),
      mergeMap(() =>
        this.repoBusinessService.getRepoBusinesses().pipe(
          map((repoBusinesses) => repoBusinessActions.loadRepoBusinessesSuccess({ repoBusinesses })),
          catchError((error) => of(repoBusinessActions.loadRepoBusinessesFailure({ error })))
        )
      )
    )
  );

  loadPositions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.loadPositions),
      mergeMap(() =>
        this.repoBusinessService.getPositions().pipe(
          map((positions) => repoBusinessActions.loadPositionsSuccess({ positions })),
          catchError((error) => of(repoBusinessActions.loadPositionsFailure({ error })))
        )
      )
    )
  );

  deletePosition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.deletePosition),
      mergeMap(({ positionId }) =>
        this.repoBusinessService.deletePosition(positionId).pipe(
          map((positions) => repoBusinessActions.deletePositionSuccess({ positions })),
          catchError((error) => of(repoBusinessActions.deletePositionFailure({ error })))
        )
      )
    )
  );

  deleteBusiness$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.deleteBusiness),
      mergeMap(({ repoBusinessId }) =>
        this.repoBusinessService.deleteBusiness(repoBusinessId).pipe(
          map((deleted) => repoBusinessActions.deleteBusinessSuccess({ deleted })),
          catchError((error) => of(repoBusinessActions.deleteBusinessFailure({ error })))
        )
      )
    )
  );

  loadContactsByRepoBusinessId$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.loadContactsByRepoBusinessId),
      mergeMap(({ repoBusinessId }) =>
        this.repoBusinessService.getContactsByRepoBusinessId(repoBusinessId).pipe(
          map((repoContacts) => repoBusinessId ? repoBusinessActions.loadContactsByRepoBusinessIdSuccess({ repoContacts }) : repoBusinessActions.loadContactsSuccess({ repoContacts })),
          catchError((error) => of(repoBusinessActions.loadContactsByRepoBusinessIdFailure({ error })))
        )
      )
    )
  );

  saveRepoBusiness$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.saveRepoBusiness),
      mergeMap(({ repoBusiness }) =>
        this.repoBusinessService.saveRepoBusiness(repoBusiness).pipe(
          map((savedRepoBusiness) => repoBusinessActions.saveRepoBusinessSuccess({ repoBusiness: savedRepoBusiness })),
          catchError((error) => of(repoBusinessActions.saveRepoBusinessFailure({ error })))
        )
      )
    )
  );

  savePosition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.savePosition),
      mergeMap(({ position }) =>
        this.repoBusinessService.savePosition(position).pipe(
          map((savedPosition) => repoBusinessActions.savePositionSuccess({ position: savedPosition })),
          catchError((error) => of(repoBusinessActions.savePositionFailure({ error })))
        )
      )
    )
  );

  saveRepoContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(repoBusinessActions.saveRepoContact),
      mergeMap(({ repoContact }) =>
        this.repoBusinessService.saveRepoContact(repoContact).pipe(
          map((savedRepoContact) => repoBusinessActions.saveRepoContactSuccess({ repoContact: savedRepoContact })),
          catchError((error) => of(repoBusinessActions.saveRepoContactFailure({ error })))
        )
      )
    )
  );
}
